import {
  ActionIcon,
  Box,
  Button,
  Flex,
  Grid,
  Loader,
  LoadingOverlay,
  Select,
  Textarea,
  TextInput,
  Title,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconCheck, IconRefresh } from "@tabler/icons-react";
import {
  repositoryDelivery,
  repositoryMdm,
  repositoryPos,
} from "../../../_base/_const/_constVar";
import { MessageResponse } from "../../../model/MessageResponse";
import { useForm } from "@mantine/form";
import { useEffect, useState } from "react";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { modals } from "@mantine/modals";

interface CreateReasonRequestTransferModal {
  id: number;
  code: string;
  name: string;
  type: string;
  note: string;
  createdAt: string;
  createBy: number;
  lastUpdatedAt: string;
  lastUpdatedBy: number;
}

const CreateReasonRequestTransfer = ({
  view,
  onSuccess,
  data,
}: {
  view: string;
  onSuccess: any;
  data: CreateReasonRequestTransferModal;
}) => {
  const [visible, { toggle, open, close }] = useDisclosure(false);
  const [codeCN, setCodeCN] = useState<string>("");
  const [codeNB, setCodeNB] = useState<string>("");

  const form = useForm<CreateReasonRequestTransferModal>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      id: 0,
      code: "",
      name: "",
      type: "CN",
      note: "",
      createdAt: "",
      createBy: 0,
      lastUpdatedAt: "",
      lastUpdatedBy: 0,
    },

    validate: {
      type: (value: string) => {
        if (!value) {
          return "Vui lòng chọn loại điều chuyển áp dụng !";
        }
      },
      name: (value: string) => {
        if (!value || value.length < 2) {
          return "Lý do YCDC phải có ít nhất 2 kí tự !";
        }
      },
    },
  });

  const handleGenCode = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      `/api/v1/TblTransferReason/generate-code?type=${form.getValues().type}`,
    );

    if (res && res.success) {
      if (form.getValues().type === "CN") {
        if (!codeCN) {
          setCodeCN(res.code);
        }
      } else {
        if (!codeNB) {
          setCodeNB(res.code);
        }
      }
    }
  };

  const handleCreate = async (dataSubmit: CreateReasonRequestTransferModal) => {
    open();
    try {
      const res = await repositoryPos.post<MessageResponse<any>>(
        `/api/v1/TblTransferReason/create`,
        dataSubmit,
      );

      if (res && res.success) {
        NotificationExtension.Success("Tạo mới lý do YCDC thành công !");
        setTimeout(() => {
          onSuccess();
          modals.closeAll();
        }, 1000);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  const handleUpdate = async (dataSubmit: CreateReasonRequestTransferModal) => {
    open();
    try {
      const res = await repositoryPos.post<MessageResponse<any>>(
        `/api/v1/TblTransferReason/edit`,
        dataSubmit,
      );

      if (res && res.success) {
        NotificationExtension.Success("Chỉnh sửa lý do YCDC thành công !");
        setTimeout(() => {
          onSuccess();
          modals.closeAll();
        }, 1000);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  useEffect(() => {
    if (form.getValues().type && (!codeCN || !codeNB) && view === "create") {
      handleGenCode();
    }
  }, [form.getValues().type]);

  useEffect(() => {
    if (view === "update") {
      form.setValues(data);

      if (data?.type === "CN") {
        setCodeCN(data?.code);
      } else {
        setCodeNB(data?.code);
      }
    }
  }, [view]);

  return (
    <Box
      component="form"
      maw={450}
      w={"30vw"}
      pt={10}
      onSubmit={form.onSubmit((e: CreateReasonRequestTransferModal) => {
        if (view === "create") {
          handleCreate({
            ...e,
            code: e.type === "CN" ? codeCN : codeNB,
            createdAt: new Date(
              new Date().getTime() + 7 * 3600 * 1000,
            ).toISOString(),
            lastUpdatedAt: new Date(
              new Date().getTime() + 7 * 3600 * 1000,
            ).toISOString(),
          });
        } else {
          handleUpdate({
            ...e,
            lastUpdatedAt: new Date(
              new Date().getTime() + 7 * 3600 * 1000,
            ).toISOString(),
          });
        }
      })}
    >
      <LoadingOverlay
        visible={visible}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 5 }}
        loaderProps={{
          children: (
            <Flex direction={"column"} align="center" gap="xs">
              <Loader type="dots" size={35}></Loader>
              {/* <Title size={15}> Đang upload tài liệu...</Title> */}
              <Title size={12}>
                {" "}
                Hệ thống đang xử lý dữ liệu, vui lòng chờ trong giây lát ...
              </Title>
            </Flex>
          ),
        }}
      />
      <Grid>
        <Grid.Col span={{ base: 12, md: 6 }}>
          <Select
            label="Áp dụng cho loại điều chuyển"
            placeholder="Chọn loại điều chuyển được áp dụng"
            data={[
              {
                label: "Điều chuyển chi nhánh",
                value: "CN",
              },
              { label: "Điều chuyển nội bộ", value: "NB" },
            ]}
            value={form.getValues().type ? form.getValues().type : null}
            {...form.getInputProps("type")}
            onChange={(e) => {
              form.setValues((prev) => ({
                ...prev,
                type: e ? e : "",
              }));
            }}
            variant={view === "update" ? "filled" : "default"}
            readOnly={view === "update"}
            withAsterisk
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6 }}>
          <TextInput
            label="Mã lý do YCDC"
            placeholder="Nhập mã lý do YCDC"
            value={form.getValues().type === "CN" ? codeCN : codeNB}
            variant={"filled"}
            readOnly
          />
        </Grid.Col>
        <Grid.Col span={12}>
          <TextInput
            key={form.key("name")}
            label="Lý do YCDC"
            placeholder="Nhập lý do YCDC"
            withAsterisk
            {...form.getInputProps("name")}
          />
        </Grid.Col>
        <Grid.Col span={12}>
          <Textarea
            key={form.key("note")}
            label="Ghi chú"
            placeholder="Nhập ghi chú"
            {...form.getInputProps("note")}
          />
        </Grid.Col>
      </Grid>
      <Flex justify={"center"} mt={10}>
        <Button
          leftSection={<IconCheck size={16} />}
          loading={visible}
          disabled={visible}
          type="submit"
        >
          Lưu
        </Button>
      </Flex>
    </Box>
  );
};

export default CreateReasonRequestTransfer;
